export const spotTypes = {
    IFE: "ife",
    IAC: "iac"
}

export const fieldsToSplitByLocality = [
    "Medicina Geral e Familiar"
]

export const startYears = [
    2016,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022,
    2023
]

export const fetchDataResults = {
    SUCCESS: "success",
    USER_NOT_LOGGED_IN: "user not logged in",
    USER_EMAIL_NOT_VERIFIED: "user email not confirmed",
    USER_NOT_PREMIUM: "user does not have a premium account",
    FAILURE: "failure"
}

export const dataVizTypes = {
    LAST_SPOTS_PER_YEAR: "Últimas vagas preenchidas por ano",
    SPOTS_PER_YEAR: "Distribuição das vagas preenchidas por ano",
    SPOTS_PER_DISTRICT_IN_YEAR: "Distribuição das vagas preenchidas por distrito",
    SPOTS_PER_YEAR_IN_DISTRICT: "Distribuição das vagas preenchidas por ano e por distrito"
}

export const premiumRole = "premium";
